// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3RtZB","modalForm":"UpgradeEpcsModal_modalForm__PwYKT","modalFooter":"UpgradeEpcsModal_modalFooter__2kW8N"};